<template>
  <el-popover
    placement="bottom-start"
    trigger="hover"
  >
    <div class="feet">
      <!--下载模板-->
      <el-button type="primary" size="small" @click="onDownloadTemplate">{{ $t('basicData.DownloadTheTemplate') }}</el-button>

      <!--批量导入-->
      <upload-excel
        class="feet-btn"
        :on-success="importLogistics"
        :but-name="$t('basicData.BulkImport')"
      />

      <!--下载报价-->
      <el-button type="primary" size="small" @click="downloadOffer">{{ $t('basicData.DownloadTheQuote') }}</el-button>
    </div>
    <!--导入/下载-->
    <template #reference>
      <el-button
        size="small"
        plain
      >{{ $t('basicData.ImportDownload') }}</el-button>
    </template>
  </el-popover>
</template>

<script>
import { downloadTemplate, importTemplate, downloadQuotation } from './utils';

export default {
  components: {
    'upload-excel': () => import('@/components/UploadExcel/index.vue')
  },

  props: {
    // 所有分区
    subregionList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 费用
    feeList: {
      type: Array,
      default: () => [],
      required: true
    },
    // 下载模板需要的回调函数
    getDataFunc: {
      type: Function,
      required: true
    }
  },

  methods: {
    // 下载模板
    onDownloadTemplate() {
      const list = this.subregionList;
      downloadTemplate(list, this.feeList);
    },

    // 批量导入报价
    importLogistics(fileData) {
      try {
        const list = this.subregionList;
        const arr = importTemplate(list, fileData);
        this.$emit('importList', arr);
      } catch (error) {
        this.$message.warning(this.$t('orderCenterCont.ImportFailed'));
      }
    },

    // 下载报价
    downloadOffer() {
      const data = this.getDataFunc();
      const list = this.subregionList;
      downloadQuotation(list, this.feeList, data);
    }
  }
};
</script>
